module.exports = __webpack_public_path__ + "static/media/icon-booth-rev-housing.97da705e.svg";